import { Card, CardWithIntent } from "@clipboard-health/ui-components";
import { CardContent } from "@mui/material";

import { useInterviewMessage } from "../hooks/useInterviewMessage";
import {
  PlacementApplicationMessage,
  PlacementApplicationMessageBaseProps,
} from "./PlacementApplicationMessage";

interface PlacementApplicationMessageCardProps extends PlacementApplicationMessageBaseProps {
  workerTimezone: string;
  hasActiveBan: boolean;
}

export function PlacementApplicationMessageCard(props: PlacementApplicationMessageCardProps) {
  const { interviews, workerTimezone, hasActiveBan } = props;

  const { hasBookedInterview, title, subtitle } = useInterviewMessage({
    interviews,
    workerTimezone,
    hasActiveBan,
  });

  const content = (
    <CardContent>
      <PlacementApplicationMessage
        {...props}
        title={title}
        subtitle={subtitle}
        hasBookedInterview={hasBookedInterview}
      />
    </CardContent>
  );

  if (hasBookedInterview) {
    return (
      <CardWithIntent
        intent="success"
        sx={{ background: (theme) => theme.palette.intent?.success.gradient }}
      >
        {content}
      </CardWithIntent>
    );
  }

  return (
    <Card outlined variant="primary">
      {content}
    </Card>
  );
}
